import { render, staticRenderFns } from "./NewReInsuranceDic.vue?vue&type=template&id=085300f6&scoped=true&"
import script from "./NewReInsuranceDic.vue?vue&type=script&lang=js&"
export * from "./NewReInsuranceDic.vue?vue&type=script&lang=js&"
import style0 from "./NewReInsuranceDic.vue?vue&type=style&index=0&id=085300f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085300f6",
  null
  
)

export default component.exports